import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CSFProductGrid from 'components/CreatorStoreFront/CSFProductGrid/CSFProductGrid';
import CSFProductGridEN from 'components/CreatorStoreFront/CSFProductGrid/locales/CSFProductGrid_en_US.js';
import CSFProductGridFR from 'components/CreatorStoreFront/CSFProductGrid/locales/CSFProductGrid_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CSFProductGridEN, CSFProductGridFR);

const withCSFProductGridLocale = wrapHOC(WrappedComponent => {
    const CSFProductGridWithLocale = props => (
        <WrappedComponent
            {...props}
            getText={getText}
        />
    );

    return CSFProductGridWithLocale;
});

export default withCSFProductGridLocale(CSFProductGrid);
